import React from "react";
import T from "prop-types";
import ActionDropDown from "MODULES/shared/components/ActionDropDown/ActionDropDown";
import { Authorized, Forbidden } from "MODULES/shared/components";
import {
  ACCOUNTING,
  CAN_RELEASE_ACCOUNTING_HOLD,
  CREATE_COC,
  QUALITY_CONTROL,
  QUALITY_CONTROL_MANAGER,
  WAREHOUSE,
  WAREHOUSE_LOGISTICS_DIRECTOR
} from "MODULES/users/constants";
import Sync from "MODULES/SalesOrders/components/Detail/Actions/Sync/Sync";
import DownloadProForma from "MODULES/SalesOrders/components/Detail/Actions/DownloadProForma/DownloadProForma";
import CreateCommercialInvoice from "MODULES/SalesOrders/components/Detail/Actions/CreateCommercialInvoice/CreateCommercialInvoice";
import { loadRecord } from "MODULES/shared/decorators";
import * as actions from "MODULES/SalesOrders/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import RemoveExportHold from "MODULES/SalesOrders/components/Detail/Actions/RemoveExportHold/RemoveExportHold";
import { ID } from "APP_ROOT/constants";
import ExportHold from "MODULES/SalesOrders/components/Detail/Actions/ExportHold/ExportHold";
import Download from "MODULES/SalesOrders/components/Detail/Actions/DownloadCoC/Download";
import SyncCoreRepairCharges from "MODULES/SalesOrders/components/Detail/Actions/SyncCoreRepairCharges/SyncCoreRepairCharges";
import NewCompanyHold from "MODULES/SalesOrders/components/Detail/Actions/NewCompanyHold/NewCompanyHold";
import ToggleQuickbooksSync from "MODULES/SalesOrders/components/Detail/Actions/ToggleQuickbooksSync/ToggleQuickbooksSync";
import Cancel from "./Cancel/Cancel";
import Release from "./Release";
import ReleaseExchangeAgreementHold from "./ReleaseExchangeAgreement";
import AddAccountingHold from "./AddAccountingHold";
import DownloadPackingSlip from "./DownloadPackingSlip";
import DownloadDiscreetPackingSlip from "./DownloadDiscreetPackingSlip";
import CancellationReversal from "./CancellationReversal";
import EditInvoiceDetails from "./EditInvoiceDetails/EditInvoiceDetails";

function Actions({ salesOrderWithAllLineItems, cancelled }) {
  const salesOrder = salesOrderWithAllLineItems.toJS();

  return (
    <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
      <ActionDropDown menuClass="dropdown-menu-right">
        <Authorized roles={[ACCOUNTING]}>
          <EditInvoiceDetails salesOrder={salesOrder} />
        </Authorized>
        {!cancelled ? (
          <React.Fragment>
            <Authorized
              permissions={[CAN_RELEASE_ACCOUNTING_HOLD]}
              roles={[ACCOUNTING]}
            >
              <Release />
              <ReleaseExchangeAgreementHold />
              <AddAccountingHold />
            </Authorized>
            <Authorized
              roles={[QUALITY_CONTROL]}
              subroles={[WAREHOUSE_LOGISTICS_DIRECTOR]}
            >
              <NewCompanyHold />
              <RemoveExportHold />
              <ExportHold />
            </Authorized>
            <DownloadPackingSlip salesOrder={salesOrder} />
            <DownloadDiscreetPackingSlip salesOrder={salesOrder} />
            <DownloadProForma />
            <Authorized
              permissions={[CREATE_COC]}
              roles={[QUALITY_CONTROL]}
              subroles={[QUALITY_CONTROL_MANAGER]}
            >
              <Download salesOrder={salesOrder} />
            </Authorized>
            <Authorized roles={[ACCOUNTING]}>
              <ToggleQuickbooksSync salesOrder={salesOrder} />
              <Sync />
              <SyncCoreRepairCharges salesOrder={salesOrder} />
            </Authorized>
            <CreateCommercialInvoice salesOrder={salesOrder} />
            <Authorized
              roles={[ACCOUNTING, QUALITY_CONTROL]}
              authorizedIf={user => user.get(ID) === salesOrder.created_by_id}
            >
              <li className="divider" role="separator" />
              <Cancel salesOrder={salesOrder} />
            </Authorized>
          </React.Fragment>
        ) : (
          <Forbidden roles={[WAREHOUSE]}>
            <CancellationReversal />
          </Forbidden>
        )}
      </ActionDropDown>
    </div>
  );
}

export default withRouter(
  connect(state => ({
    salesOrderWithAllLineItems: state.salesOrderWithAllLineItemsDetail.get(
      "salesOrderWithAllLineItems"
    )
  }))(
    loadRecord({
      reducer: "salesOrderWithAllLineItemsDetail",
      name: "salesOrderWithAllLineItems",
      action: id => actions.fetchSalesOrderWithAllLineItems(id, true)
    })(Actions)
  )
);

Actions.propTypes = {
  cancelled: T.bool
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/Actions.jsx